import TtamRecommendInterestBehaviorApplyBtn from './apply-btn/index.vue';
import TtamRecommendInterestBehaviorMoreDialog from './more-dialog/index.vue';
import TtamRecommendInterestBehaviorSummary from './summary/index.vue';

import * as hooks from './hooks';
export default {
  TtamRecommendInterestBehaviorApplyBtn,
  TtamRecommendInterestBehaviorSummary,
  TtamRecommendInterestBehaviorMoreDialog,
  ...hooks,
};
